import IPayload from "../interfaces/IPayload";

import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class ParametrizacaoRebateService {
    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.parametrizacaoRebate}/filters/${ToQueryString(filters)}`);
    }

    async create(data: any) {
        return await api.post<any>(`${resources.parametrizacaoRebate}`, {
            ...data,
            classe: typeof data.classe === "string" ? null : data.classe,
        });
    }

    async update(data: any) {
        return await api.put<any>(`${resources.parametrizacaoRebate}`, data);
    }
}

export default new ParametrizacaoRebateService();
